import styled from 'styled-components'

const StyledShareDialog = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  padding: 20px;
  box-sizing: border-box;
  display: grid;
  align-items: center;
  justify-content: center;

  .backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0, 0.8);
  }

  .dialog {
    position: relative;
    box-sizing: border-box;
    max-width: 370px;
    width: 100vw;
    background-color: ${({ theme }) => theme.color.background};
    border-radius: 10px;
    overflow: hidden;
    overflow-y: auto;
    max-height: 100%;

    .course-details-container {
      padding: 28px 28px 0 28px;

      .course-preview {
        background-color: ${({ theme }) => theme.color.gray[100]};
        padding-top: 56.25%;
        border-radius: 6px;
        overflow: hidden;
        position: relative;
        box-shadow: 0 2px 2px rgb(0, 0, 0, 0.1), 0 6px 10px rgb(0, 0, 0, 0.1);

        img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .course-details {
        margin-top: 20px;

        .course-title {
          font-weight: 600;
          font-size: 16px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-align: left;
          -webkit-box-orient: vertical;
          color: ${({ theme }) => theme.color.gray[800]};
        }

        .course-description {
          margin-top: 10px;
          font-size: 14px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-align: left;
          -webkit-box-orient: vertical;
          line-height: 18px;
          color: ${({ theme }) => theme.color.gray[500]};
        }
      }
    }

    .share-container {
      padding: 28px;
      overflow: hidden;
      overflow-x: auto;
      box-sizing: border-box;
      width: 100%;

      .share-actions {
        display: flex;
        width: fit-content;

        button {
          flex-shrink: 0;
          background-color: transparent;
          transition: 0.2s;

          .icon {
            height: 60px;
            width: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${({ theme }) => theme.color.gray[200]};
            color: ${({ theme }) => theme.color.background};
            transition: 0.2s;

            svg {
              height: 30px;
              width: 30px;
            }
          }

          .label {
            margin-top: 10px;
            display: block;
            text-align: center;
            font-size: 11px;
            font-weight: 500;
            transition: 0.2s;
            color: ${({ theme }) => theme.color.gray[500]};
          }

          &[data-platform='instagram'] .icon {
            background-color: #e4405f;
          }

          &[data-platform='facebook'] .icon {
            background-color: #0866ff;
          }

          &[data-platform='snapchat'] .icon {
            background-color: #fffc00;
          }

          &[data-platform='linkedin'] .icon {
            background-color: #0a66c2;
          }

          &[data-platform='x'] .icon {
            background-color: #000000;
          }

          &[data-platform='messages'] .icon {
            background-color: #2fd64b;
          }

          &.icon-btn {
            .icon {
              color: ${({ theme }) => theme.color.gray[500]};
            }
          }

          &:not(:last-child) {
            margin-right: 20px;
          }

          &:hover,
          &:active,
          &:focus-visible {
            .icon {
              background-color: ${({ theme }) => theme.color.gray[800]};
              color: ${({ theme }) => theme.color.background};
              box-shadow: 0 2px 2px rgb(0, 0, 0, 0.1), 0 6px 10px rgb(0, 0, 0, 0.1);
            }

            .label {
              color: ${({ theme }) => theme.color.gray[800]};
            }
          }

          &:active {
            .icon {
              transform: scale(0.93);
            }
          }
        }
      }
    }
  }
`

export default StyledShareDialog
